export default __webpack_public_path__ + "static/media/new-for-postal-removebg.3b52d8ea.png";